export default {
  name: 'AppSection',
  props: {
    wide: {
      type: Boolean,
    },
    center: {
      type: Boolean,
    },
    className: {
      type: String
    },
    col: {
      type: String
    },
    flex: {
      type: Boolean
    },
  },
  computed: {
    cName () {
      let className = 'sip_section '
      if(this.wide) {
        className += 'sip_section__wide '
      }
      if(this.center) {
        className += 'sip_section__center '
      }
      if(this.flex) {
        className += 'sip_section__flex '
      }
      if(this.className) {
        className += `${this.className} `
      }
      if(this.col) {
        className += `sip_col_${this.col} `
      }
      return className
    }
  },
  render: function (createElement) {
    
    // console.log('>>', this.$slots.default)
    // console.log('>>', this.wide, this.center)
    // console.log('>>', this.$attrs)
    return createElement('section',
      {
        attrs: {
          class: this.cName
        },
        on: this.$listeners,
      }, this.$slots.default)
  }
}